import { render } from "./PersonalCabinetPage.vue?vue&type=template&id=9b570ab4"
import script from "./PersonalCabinetPage.vue?vue&type=script&lang=js"
export * from "./PersonalCabinetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__